import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import AppTheme from '../shared-theme/AppTheme';
import TalentRealmLogo from '../assets/TalentRealm2.svg';
import { useNavProgress } from "./NavProgressContext";
import LinearProgress from '@mui/material/LinearProgress';
import { useAuth } from '../auth/AuthContext';
import { useLocation } from 'react-router-dom';

export default function AppAppBar() {

   const { loading } = useNavProgress(); // 👈 access global state
   const { isAuthenticated } = useAuth();
   const location = useLocation(); // 👈 get current path

   const hideNavLinks = location.pathname === "/signin" || location.pathname === "/signup";

  return (
    <AppTheme>
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          {/* Logo / Brand */}
          <a href="/" style={{ display: "flex", alignItems: "center" }}>
              <img
                  src={TalentRealmLogo}
                  alt="TalentRealm Logo"
                  style={{ height: 32 }}
              />
          </a>

          {!hideNavLinks && (
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
            <Button href="#features" color="inherit">
              Features
            </Button>
            <Button href="#highlights" color="inherit">
              Highlights
            </Button>
            <Button href="#pricing" color="inherit">
              Pricing
            </Button>
            <Button href="#faq" color="inherit">
              FAQ
            </Button>
          </Box>
          )}
          {/* Auth buttons */}
          <Box sx={{ display: 'flex', gap: 1 }}>
              {isAuthenticated ? (
                <Button
                  href="/app"
                  variant="contained"
                  color="primary"
                  disableElevation
                >
                  Go to App
                </Button>
              ) : (
                <>
                  <Button href="/signin" color="inherit">
                    Login
                  </Button>
                  <Button
                    href="/signup"
                    variant="contained"
                    color="primary"
                    disableElevation
                  >
                    Sign Up
                  </Button>
                </>
              )}
          </Box>
        </Toolbar>
      </Container>
      {loading && <LinearProgress sx={{height:"1px",}} color="primary" />}
    </AppBar>
    </AppTheme>
  );
}
